<div class="border rounded p-3 bg-white" *ngIf="!hideTopHeaderDisplay">
  <div class="row g-3">
    <div class="col-md-2">
      <p><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
    </div>
    <div class="col-md-2"><strong class="mt-2">Name</strong> : {{vendorName}}</div>
    <div class="col-md-2">
      <p><strong>Phone</strong> : {{telephone | phoneFormat}}</p>
    </div>
    <div class="col-md-2"><strong>City</strong> : {{City}}</div>
    <div class="col-md-4"><strong>Email</strong> : {{Email}}</div>

    <div class="col-md-3">
      <label class="form-label fw-bold">{{ 'Vendor Comments' | wordReplace }}</label>
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="finalvendorComment">
        <button class="btn btn-dark ms-2" style="padding-bottom: 12px; border-radius: 6px;" type="button"
          (click)="bindVendorComments()">...</button>
      </div>
    </div>
    <div class="col-md-3">
      <label class="form-label fw-bold">Rental Notes</label>
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="finalRentalNotes">
        <button class="btn btn-dark ms-2" style="padding-bottom: 12px; border-radius: 6px;" type="button"
          data-bs-toggle="modal" data-bs-target="#modalRentalNotes" (click)="bindRentalNotes()">...</button>
      </div>
    </div>

    <div class="col-md-3">
      <label class="form-label fw-bold">Rental End Month</label>
      <div class="input-group">
        <select class="form-select" (change)="checkSelectedEndDates()" [(ngModel)]="monthlyRentalEndDate">
          <option *ngFor="let item of monthlyMarketDays;" [value]="item.RentalMonths">
            {{item.RentalMonths}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div>
  <ul class="nav nav-tabs custom-tabs mt-2" id="vendorTab" role="tablist" *ngIf="!hideTopHeaderDisplay">
    <li class="nav-item" *ngFor="let tab of visibleTabs; let i = index" role="presentation">
      <button class="nav-link" [class.active]="activeTab === tab.key" (click)="selectTab(tab.key)" type="button"
        role="tab">
        {{ tab.label }}
      </button>
    </li>
  </ul>
  <div class="tab-content border border-top-0 rounded-bottom p-3 bg-white">
    <ng-container [ngSwitch]="activeTab">
      <div *ngSwitchCase="'Daily'">
        <app-ops-vendor-daily-rental></app-ops-vendor-daily-rental>
      </div>
      <div *ngSwitchCase="'Weekly'">
        <app-ops-vendor-weekly-rental></app-ops-vendor-weekly-rental>
      </div>
      <div *ngSwitchCase="'Monthly'">
        <app-ops-vendor-monthly-rental [vendorId]="vendorId" (isFormDirty)="setDirtyFlag($event)"
          (hideTopHeaders)="hideHeaders($event)" [selectedEndDates]="selectedEndDates" [UserPermission]="userPermission"
          [dayendOrOpenCashNotSaved]="dayendOrOpenCashNotSaved" [terminalNoSet]="terminalNoSet"
          [vendorIsInactive]="vendorIsInactive"
          [defaultRentalNotes]="finalRentalNotes"></app-ops-vendor-monthly-rental>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal fade" id="modalVendorComments" #modalVendorComments aria-hidden="true"
  aria-labelledby="modalVendorCommentsLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalVendorCommentsLabel">Vendor Comments</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <textarea class="form-control" style="height: 200px;" [(ngModel)]="vendorComments"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnAS" (click)="saveVendorComments()" data-bs-dismiss="modal">Save</button>
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalRentalNotes" #modalRentalNotes data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalRentalNotesLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalRentalNotesLabel">Rental Notes</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <textarea class="form-control" style="height: 200px;" [(ngModel)]="rentalNotes"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnAS" data-bs-dismiss="modal" (click)="saveRentalNotes()">Save</button>
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
